import axios from "axios";
import { SENT_COLLABORATIONS_URL } from "../../utils";

export const fetchSentCollaborations = () => {
  return axios.get(SENT_COLLABORATIONS_URL);
};
